module.exports = __webpack_public_path__ + "img/patient-info-desktop-fr.884fa667.jpg";